import { Component, OnInit, Input, Output, EventEmitter, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.scss']
})
export class BlockComponent implements OnInit {

  comment = '';
  currentReason;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>, ) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close({
      result: false
    })
  }

  confirm() {
    this.dialogRef.close({
      result: true,
      comment: this.comment,
      reason: this.currentReason
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/block/block.component.ts